<template>
	<div class="mt-5">
		<div v-if="authenticated">
			<button style="margin-bottom: 20px;" class="btn btn-default" v-on:click="toggleAddTalk">Add talk</button>
			<div id="newTalk" class="row" v-if="viewAddTalk">
				<div class="col-md-6">
					<div class="form-group">
						<label>Bible Passage</label>
						<input type="text" class="form-control" v-model="newTalk.biblePassage" />
					</div>
					<div class="form-group">
						<label>Speaker</label>
						<input type="text" class="form-control" v-model="newTalk.speaker" />
					</div>
					<div class="form-group">
						<label>Date</label>
						<input type="date" class="form-control" v-model="newTalk.date" />
					</div>
					<div class="form-group">
						<label>Series</label>
						<input type="text" class="form-control" v-model="newTalk.seriesTitle" />
					</div>
				</div>
				<div class="col-md-3">
					<label>Upload Recording</label>
					<div class="form-group">
						<vue-dropzone id="recordingUploadDropzone" :options="dropzoneOptions" v-on:vdropzone-success="uploadedFile('sermonRecordingUrl', ...arguments)"></vue-dropzone>
					</div>
					<label>Upload Handout</label>
					<div class="form-group">
						<vue-dropzone id="handoutUploadDropzone" :options="dropzoneOptions" v-on:vdropzone-success="uploadedFile('handoutUrl', ...arguments)"></vue-dropzone>
					</div>
					<button v-on:click="saveTalk(newTalk)" v-bind:disabled="disableSave" class="btn btn-primary">Save</button>
				</div>
				<div class="col-md-3">
					<label>Upload PowerPoint</label>
					<div class="form-group">
						<vue-dropzone id="powerpointUploadDropzone" :options="dropzoneOptions" v-on:vdropzone-success="uploadedFile('powerPointUrl', ...arguments)"></vue-dropzone>
					</div>
					<label>Upload Transcript</label>
					<div class="form-group">
						<vue-dropzone id="transcriptUploadDropzone" :options="dropzoneOptions" v-on:vdropzone-success="uploadedFile('transcriptUrl', ...arguments)"></vue-dropzone>
					</div>
				</div>
			</div>
		</div>
		<div class="row" style="margin-bottom: 20px;">
			<div class="col-md-2">
				<select class="form-control" v-model="selectedBook">
					<option value="">Select book</option>
					<option v-for="book in bibleBooks">{{book.name}}</option>
				</select>
			</div>
			<div class="col-md-2">
				<select class="form-control" v-model="selectedChapter">
					<option value="">Select chapter</option>
					<option v-for="chapter in chapters">{{chapter}}</option>
				</select>
			</div>
			<div class="col-md-2">
				<select class="form-control" v-model="selectedPreacher">
					<option value="">Select speaker</option>
					<option v-for="preacher in preachers">{{preacher}}</option>
				</select>
			</div>
			<div class="col-md-2">
				<select class="form-control" v-model.number="selectedYear">
					<option value="">Select year</option>
					<option v-for="year in years">{{year}}</option>
				</select>
			</div>
			<div class="col-md-2">
				<select class="form-control" v-model.number="selectedMonth">
					<option value="">Select month</option>
					<option v-for="month in months" v-bind:value="month.id">{{month.name}}</option>
				</select>
			</div>
			<div class="col-md-2">
				<button v-on:click="clearFilters" class="btn btn-link text-right">Clear filters</button>
			</div>
		</div>
		<table class="table table-striped table-dark table-responsive-sm">
			<thead>
				<tr>
					<th>Bible passage</th>
					<th>Speaker</th>
					<th>Date</th>
					<th>Series</th>
					<th>Audio</th>
					<th colspan="3"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="talk in filteredTalks">
					<td>{{talk.biblePassage}}</td>
					<td>{{talk.speaker}}</td>
					<td>{{talk.date | formatDate}}</td>
					<td>{{talk.seriesTitle}}</td>
					<td>
						<a v-bind:href="talk.sermonRecordingUrl"><span class="fa fa-download"></span></a>
					</td>
					<td>
						<a v-if="talk.handoutUrl" v-bind:href="talk.handoutUrl">Handout</a>
					</td>
					<td>
						<a v-if="talk.powerPointUrl" v-bind:href="talk.powerPointUrl">PowerPoint</a>
					</td>
					<td>
						<a v-if="talk.transcriptUrl" v-bind:href="talk.transcriptUrl">Transcript</a>
					</td>
					<td v-if="authenticated"><button class="btn btn-danger" v-on:click="deleteTalk(talk)">Delete</button></td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import $ from 'jquery';
    import moment from 'moment';
	export default {
		name: 'talkscontent-component',
		props: ['contentData', 'index', 'hide', 'dragging', 'authenticated'],
		data() {
			return {
                dropzoneOptions:{
                    url: "/api/file/UploadSermon",
                    thumbnailWidth: 50,
                    thumbnailHeight: 50,
                    maxFilesize: 50
                },
				talks: [],
				bibleBooks: [
					{ name: "Genesis", chapters: 50 },
					{ name: "Exodus", chapters: 40 },
					{ name: "Leviticus", chapters: 27 },
					{ name: "Numbers", chapters: 36 },
					{ name: "Deuteronomy", chapters: 34 },
					{ name: "Joshua", chapters: 24 },
					{ name: "Judges", chapters: 21 },
					{ name: "Ruth", chapters: 4 },
					{ name: "1 Samuel", chapters: 31 },
					{ name: "2 Samuel", chapters: 24 },
					{ name: "1 Kings", chapters: 22 },
					{ name: "2 Kings", chapters: 25 },
					{ name: "1 Chronicles", chapters: 29 },
					{ name: "2 Chronicles", chapters: 36 },
					{ name: "Ezra", chapters: 10 },
					{ name: "Nehemiah", chapters: 13 },
					{ name: "Esther", chapters: 10 },
					{ name: "Job", chapters: 42 },
					{ name: "Psalms", chapters: 150 },
					{ name: "Proverbs", chapters: 31 },
					{ name: "Ecclesiastes", chapters: 12 },
					{ name: "Song of Songs", chapters: 8 },
					{ name: "Isaiah", chapters: 66 },
					{ name: "Jeremiah", chapters: 52 },
					{ name: "Lamentations", chapters: 5 },
					{ name: "Ezekiel", chapters: 48 },
					{ name: "Daniel", chapters: 12 },
					{ name: "Hosea", chapters: 14 },
					{ name: "Joel", chapters: 3 },
					{ name: "Amos", chapters: 9 },
					{ name: "Obadiah", chapters: 1 },
					{ name: "Jonah", chapters: 4 },
					{ name: "Micah", chapters: 7 },
					{ name: "Nahum", chapters: 3 },
					{ name: "Habakkuk", chapters: 3 },
					{ name: "Zephaniah", chapters: 3 },
					{ name: "Haggai", chapters: 2 },
					{ name: "Zechariah", chapters: 14 },
					{ name: "Malachi", chapters: 4 },
					{ name: "Matthew", chapters: 28 },
					{ name: "Mark", chapters: 16 },
					{ name: "Luke", chapters: 24 },
					{ name: "John", chapters: 21 },
					{ name: "Acts", chapters: 28 },
					{ name: "Romans", chapters: 16 },
					{ name: "1 Corinthians", chapters: 16 },
					{ name: "2 Corinthians", chapters: 13 },
					{ name: "Galatians", chapters: 6 },
					{ name: "Ephesians", chapters: 6 },
					{ name: "Philippians", chapters: 4 },
					{ name: "Colossians", chapters: 4 },
					{ name: "1 Thessalonians", chapters: 5 },
					{ name: "2 Thessalonians", chapters: 3 },
					{ name: "1 Timothy", chapters: 6 },
					{ name: "2 Timothy", chapters: 4 },
					{ name: "Titus", chapters: 3 },
					{ name: "Philemon", chapters: 1 },
					{ name: "Hebrews", chapters: 13 },
					{ name: "James", chapters: 5 },
					{ name: "1 Peter", chapters: 5 },
					{ name: "2 Peter", chapters: 3 },
					{ name: "1 John", chapters: 5 },
					{ name: "2 John", chapters: 1 },
					{ name: "3 John", chapters: 1 },
					{ name: "Jude", chapters: 1 },
					{ name: "Revelation", chapters: 22 }
				],
				selectedBook: "",
				selectedChapter: "",
				selectedPreacher: "",
				years: [],
				selectedYear: "",
				months: [
					{ name: "Jan", id: 0 },
					{ name: "Feb", id: 1 },
					{ name: "Mar", id: 2 },
					{ name: "Apr", id: 3 },
					{ name: "May", id: 4 },
					{ name: "Jun", id: 5 },
					{ name: "Jul", id: 6 },
					{ name: "Aug", id: 7 },
					{ name: "Sep", id: 8 },
					{ name: "Oct", id: 9 },
					{ name: "Nov", id: 10 },
					{ name: "Dec", id: 11 }
				],
				selectedMonth: "",
				newTalk: {
                    sermonRecordingUrl: ''
                },
				viewAddTalk: false,
				saveSermonUrl: "/Series/SaveFile"
			}
		},
		created: function () {
			this.getTalks();
			var date = 2012
			var currentYear = new Date().getFullYear()

			while (date <= currentYear) {
				this.years.push(date);
				date++;
			}

			this.years.reverse();
		},
		methods: {
			getTalks: function () {
				var self = this;
				$.getJSON("/Series/GetAllSeriesItems")
					.done(function (data) {
						self.talks = data;
					});
			},
			clearFilters: function () {
				this.filter = "";
				this.selectedBook = "";
				this.selectedMonth = "";
				this.selectedYear = "";
				this.selectedPreacher = "";
			},
			saveTalk: function (talk) {
				var data = JSON.stringify(talk);
				this.talks.unshift(talk);
                $.ajax({
                    url: '/Series/SaveSeriesItem',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    type: 'POST',
                    data: data,
                    dataType: 'json'
                })
					.done(function (addedId) {
						talk.Id = addedId;
						this.toggleAddTalk();
					});
			},
			deleteTalk: function (talk) {
                var self = this;
				var data = JSON.stringify(talk);

                $.ajax({
                    url: '/Series/DeleteSeriesItem',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    type: 'POST',
                    data: data,
                    dataType: 'json'
                })
                    .done(function () {
                        var index = self.talks.indexOf(talk);
                        self.talks.splice(index, 1);
                    });
			},
			toggleAddTalk: function () {
				this.viewAddTalk = !this.viewAddTalk;
			},
            uploadedFile: function (property, file, response) {
                this.newTalk[property] = response.url;
            }
		},
		computed: {
			chapters: function () {
				var self = this;
				var book = this.bibleBooks.find(function (item) {
					return item.name === self.selectedBook;
				});
				if (!book) return [];
				var chaptersArray = [];
				for (var i = 1; i <= book.chapters; i++) {
					chaptersArray.push(i);
				}
				return chaptersArray;
			},
			filteredTalks: function () {
				var self = this;
				return self.talks.filter(function (item) {
					return (!self.selectedBook || (item.biblePassage || "").toLowerCase().indexOf(self.selectedBook.toLowerCase()) > -1)
						&& (!self.selectedChapter || (item.biblePassage || "").toLowerCase().indexOf(self.selectedChapter.toLowerCase()) > -1)
						&& (!self.selectedYear || moment(item.date).year() === self.selectedYear)
						&& (!self.selectedMonth || moment(item.date).month() === self.selectedMonth)
						&& (!self.selectedPreacher || (item.speaker || "").toLowerCase().indexOf(self.selectedPreacher.toLowerCase()) > -1);
				});
			},
			disableSave: function () {
				return !this.newTalk.sermonRecordingUrl;
			},
			preachers: function () {
				function onlyUnique(value, index, self) {
					return value && self.indexOf(value) === index;
				}

				var all = this.talks.map(function (item) {
					return item.speaker.trim();
				});

				return all.filter(onlyUnique).sort();
			}
		},
		filters: {
			formatDate: function (value) {
				return moment(value).format('D MMM YYYY');
			}
		},
		watch: {
			selectedBook: function (val) {
				this.selectedChapter = "";
			}
		}
	};</script>
